import React, {Component} from 'react';
import PropTypes from "prop-types";

class LoadingSplash extends Component {

    static propTypes = {
        color: PropTypes.string
    };

    constructor(props) {

        super(props);

    }

    render() {

        let style = {};

        if (this.props.color) {
            if (this.props.color === 'dark') {
                style.backgroundColor = '#0e3043';
            } else {
                style.backgroundColor = this.props.color;
            }
        }

        return (
            <div>
                {/*<!-- PreLoader -->*/}
                <div className="pagespinner">
                    <div className="balken1" style={style}>&nbsp;</div>
                    <div className="balken2" style={style}>&nbsp;</div>
                    <div className="balken3" style={style}>&nbsp;</div>
                    <div className="balken4" style={style}>&nbsp;</div>
                    <div className="balken5" style={style}>&nbsp;</div>
                </div>
                {/*<!-- / PreLoader -->*/}
            </div>
        );

    }

}

export default LoadingSplash;